/* eslint-disable no-console */
import endpoint from './microserviceEndpoints/biocatchEndpoint';

export const getCookieContent = (name) => {
	const content = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
	return content ? content[2] : '';
};

export const biocatchFetchScoreCall = ({
	accessToken,
	activityType,
	apiBaseUrl,
	apiBaseUrlPaas,
	bankId,
	clientContext,
	scoreContext,
	paymentDetails = undefined,
}) => {
	const { scoreUri, getResolvedURI, getBiocatchHeaders } = endpoint.biocatchEndpoint;
	const url = getResolvedURI(scoreUri, bankId, apiBaseUrl, apiBaseUrlPaas);
	const biocatchHeaders = getBiocatchHeaders(clientContext, accessToken);

	const { fromAccountId, toAccountId, amount, currencyCode } = paymentDetails ?? {};
	const requestData = {
		biocatch_session_id: getCookieContent('bcsid'),
		biocatch_activity_type: activityType,
		biocatch_context: scoreContext,
		...(paymentDetails && {
			payer_account_id: fromAccountId,
			payee_id: toAccountId,
			// Backend expects prop that is a mix of camelCase & snake_case...
			...(amount && { activity_Amount: amount }),
			...(currencyCode && { currency_code: currencyCode }),
		}),
	};

	fetch(url, {
		method: 'POST',
		headers: biocatchHeaders,
		body: JSON.stringify(requestData),
	}).catch((error) => console.log(error));
};
